import React, {
    ReactElement,
} from "react";
import { Droppable } from "react-beautiful-dnd";

export enum Action {
    TRANSFER = "TRANSFER",
    IGNORE = "IGNORE",
    END_CHAT = "END_CHAT",
    ASSIGN = "ASSIGN"
}
interface DropActionProps {
    dragGroup: string | undefined;
    action: Action;
    variant: string;
    text: string;
}
export default function DropAction({
    action, dragGroup, variant, text,
}: DropActionProps): ReactElement {
    const actionId = `action:${action}`;
    return (
        <Droppable
            key="ignore"
            droppableId={actionId}
            direction="horizontal"
            mode="standard"
            type={dragGroup}
        >
            {(dropStoppable, snapshot) => {
                const bgColor = snapshot.isDraggingOver ? `alert alert-${variant}` : "bg-white";
                return (
                    <div
                        className={`d-flex mx-3 mt-2 w-100 border border-${variant} border-4 rounded shadow`
                        + `text-light-200 justify-content-center align-items-center  ${bgColor}`}
                        ref={dropStoppable.innerRef}
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...dropStoppable.droppableProps}
                    >
                        {dropStoppable.placeholder}
                        <div className={`position-absolute fs-5 text-${variant}`}>
                            {text}
                        </div>
                    </div>

                );
            } }
        </Droppable>
    );
}
